import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { SvgUri } from 'react-native-svg';
import { UIConfig } from '../types/ui-config/index';
import { DyteUIContext } from '../lib/context-provider/ui-context';
import DyteSpinner from './DyteSpinner';

export default function ({ config }: { config: UIConfig }) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const styles = StyleSheet.create({
    container: {
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.background[800],
    },
    textContainer: {
      backgroundColor: colors.background[900],
      paddingHorizontal: 30,
      paddingVertical: 20,
      borderRadius: 16,
    },
  });
  // console.log(config);
  return (
    <View style={styles.container}>
      <View>
        <SvgUri
          uri={
            config !== undefined && config.designTokens.logo.trim().length > 0
              ? config.designTokens.logo
              : 'https://app.dyte.io/dyte-logo/dyte.svg'
          }
          height={
            config !== undefined
              ? Object.values(config.styles)['dyte-logo'].height
              : 100
          }
          width={
            config !== undefined
              ? Object.values(config.styles)['dyte-logo'].width
              : 100
          }
        />
      </View>
      <DyteSpinner />
    </View>
  );
}
